import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { InitialLoadingService } from '../services/initial-loading.service';
import { Observable, switchMap } from 'rxjs';
import { AccessControlService } from '../services/access-control.service';

@Injectable({ providedIn: 'root' })
export class InitialDataResolver implements Resolve<boolean> {
  constructor(private initialLoading: InitialLoadingService, private access: AccessControlService) {}

  resolve(): Observable<boolean> {
    return this.initialLoading.ensureLoaded().pipe(
      switchMap(() => this.access.ensureAllowed())
    );
  }
}
